import React from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import ExamCategoryTable from "../../components/master/ExamCategoryTable";
import { authFetch } from "../../utility/AuthFetch";

function ExamCategory() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [type, setType] = useState("Periodic Test");
  const [name, setName] = useState("");
  const [marks, setMarks] = useState("");
  const [annualPercent, setAnnualPercent] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isAnnual, setIsAnnual] = useState(false);
  const [annualPercentWithPractical, setAnnualPercentWithPractical] =
    useState("");

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = editMode
      ? `${API_BASE_URL}/api/edit-exam-category-master`
      : `${API_BASE_URL}/api/exam-category-master`;

    if (editMode) {
      formData.append("ID", editId);
    }

    const method = editMode ? "PUT" : "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          editMode
            ? "Exam Category updated successfully"
            : "Exam Category added successfully"
        );
        formRef.current.reset();
        setIsSubmitting(false);
        setType("Periodic Test");
        setName("");
        setMarks("");
        setAnnualPercent("");
        setAnnualPercentWithPractical("");
        setIsAnnual(false);
        setEditMode(false);
        setLoader(false);
        setEditId(null);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setType(item.type);
    if (item.type === "Annual Exam") {
      setIsAnnual(true);
      setAnnualPercentWithPractical(item.annualPercentWithPractical);
    } else {
      setIsAnnual(false);
      setAnnualPercentWithPractical("");
    }
    setName(item.name);
    setMarks(item.marks);
    setAnnualPercent(item.annualPercentage);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setEditId(item.id);
    setEditMode(true);
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Exam Category Master</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formExamCategory">
                    <Form.Label>
                      Exam Category <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="type"
                      value={type}
                      onChange={(e) => {
                        setType(e.target.value);
                        if (e.target.value === "Annual Exam") {
                          setIsAnnual(true);
                        } else {
                          setIsAnnual(false);
                          setAnnualPercentWithPractical("");
                        }
                      }}
                      required
                    >
                      <option value="Periodic Test">Periodic Test</option>
                      <option value="Internal Assessment">
                        Internal Assessment
                      </option>
                      <option value="Half Yearly">Half Yearly</option>
                      <option value="Annual Exam">Annual Exam</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formCategory">
                    <Form.Label>
                      Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Exam Name"
                      aria-label="Exam Name"
                      name="name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formMaximumMarks">
                    <Form.Label>
                      Maximum Marks <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Maximum Marks"
                      name="marks"
                      value={marks}
                      onChange={(e) => setMarks(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formAnnualPercentage">
                    <Form.Label>
                      Annual Percentage {isAnnual && "w/o Practical"}{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder={`Enter Annual Percentage ${
                        isAnnual ? "w/o Practical" : ""
                      }`}
                      name="annualPercentage"
                      value={annualPercent}
                      onChange={(e) => setAnnualPercent(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group
                    className="mb-3"
                    controlId="formAnnualPercentWithPractical"
                  >
                    <Form.Label>
                      {isAnnual ? "Annual Percentage With Practical" : ""}
                    </Form.Label>
                    <Form.Control
                      type={isAnnual ? "number" : "hidden"}
                      placeholder="Enter Annual Percentage With Practical"
                      name="annualPercentWithPractical"
                      value={isAnnual ? annualPercentWithPractical : ""}
                      onChange={(e) =>
                        setAnnualPercentWithPractical(e.target.value)
                      }
                      required={isAnnual}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {editMode ? "UPDATE" : "SUBMIT"}
              </Button>
            </Form>
          </div>

          <div className="container bg-white p-4 rounded shadow-sm mt-4">
            <h5 className="mb-3">Exam Category List</h5>
            <ExamCategoryTable onEdit={handleEdit} reload={reload} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExamCategory;
